import React, { useContext } from "react"
import { StepsItemContext } from './context';
import { Circle, CenterProps, Icon } from '@/index'
import { ActiveState } from "./ActiveState";
import { $color } from "@/utils/cssVarUtils";

interface StepsItemProps extends CenterProps {}

const Component = React.forwardRef((props: StepsItemProps, ref: React.Ref<any>) => {
  const { children, ...otherProps } = props

  const { active, completed } = useContext(StepsItemContext)
  const bgColor = (active || completed) ? $color('scene-primary-normal') : $color('scene-border')

  return (
    <Circle
      ref={ref}
      size='md'
      bg={bgColor}
      fontSize='xs'
      position='relative'
      { ...otherProps }
    >
      { active && <ActiveState /> }
      { completed && <Icon.Checked height="0.8em" /> }
      { !completed && children }
    </Circle>
  )
})


export {
  Component as StepsItem,
  type StepsItemProps,
}
